export const SUBMIT_RESET_PASSWORD_FORM_START =
  "SUBMIT_RESET_PASSWORD_FORM_START";
export const SUBMIT_RESET_PASSWORD_FORM_SUCCESS =
  "SUBMIT_RESET_PASSWORD_FORM_SUCCESS";
export const SUBMIT_RESET_PASSWORD_FORM_FAILURE =
  "SUBMIT_RESET_PASSWORD_FORM_FAILURE";
